import { useCallback, useEffect, useState } from 'react';

const SCROLL_THRESHOLD = 100;
const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

const toggleVisibility = useCallback(() => {
    setIsVisible(window.scrollY > SCROLL_THRESHOLD);
  }, []);

 const scrollToTop = useCallback((event: React.MouseEvent) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
      return () => window.removeEventListener('scroll', toggleVisibility);
  }, [toggleVisibility]);

  return (
  <button
      type="button"
      onClick={scrollToTop}
      className="ao_backToTop"
      style={{
        padding: 0,
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? 'auto' : 'none',
        transition: 'opacity 0.2s',
      }}
      aria-label="Back to top"
    >
      <img
        src="/assets/images/newdesign/chevron-sign.svg"
        alt="Back to top"
        width={30}
      />
    </button>
  );
};

export default ScrollToTop;
